module.exports = __webpack_public_path__ + "img/selected5-min.5efe20f2.png";